import React from 'react';
import './PostInviteModal.css';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { sendGridEmail } from '../../../../firebase/api/mail';
import { updatePost } from '../../../../firebase/api/post';
import { getAuthUser, getUserUid } from '../../../../static/localStorage';
import { getUserTeams } from '../../../../firebase/api/teams';
import { ReactComponent as InviteFriendIcon } from '../../modal/invite-friend-icon.svg';
import { getInviteToAnswer } from '../../../../templates';
import Checkbox from '../../../checkbox';
import Select, { components } from 'react-select';
import { ReactComponent as InviteTeamsLogo } from '../../../../pages/CreatePost/invite-teams-logo.svg';
import CreatableSelect from 'react-select/creatable';
import { ReactComponent as InviteIndividualLogo } from '../../../../pages/CreatePost/invite-individual-logo.svg';
import { INVITE_ALL_USERS } from '../../../../constants/post';
import { IS_SIDEKICK_APP } from '../../../../constants/projects';

class PostInviteModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            emailsSendTo: [],
            userMessage: '',
            teamsOptions: [],
            inviteAllUsers: false,
            teams: null,
            selectedTeams: null,
            selectedUsers: [],
            showTeamInvite: false,
        };
    }

    componentDidMount = () => {
        if (this.props.post.inviteColleagues.includes(INVITE_ALL_USERS)) {
            this.setState({
                inviteAllUsers: false,
            });
        }
        const userId = getUserUid();
        getUserTeams(userId).then(teams => {
            this.setState({
                userTeams: teams.map(t => ({
                    label: t.teamName,
                    value: t.teamId,
                    invitedUsers: t.invitedUsers,
                })),
            });
        });
    };

    onUsersSelect = emails => {
        this.setState({
            selectedUsers: emails,
        });
    };

    onTeamSelect = teams => {
        this.setState({
            selectedTeams: teams,
        });
    };

    inviteFriends = () => {
        const { emailsSendTo } = this.state;
        const { post } = this.props;
        post.inviteColleagues = post.inviteColleagues ? [] : post.inviteColleagues;
        emailsSendTo.forEach(email => {
            post.inviteColleagues.push(email.value);
        });
        updatePost(post).then(result => {
            if (result) {
                const mails = emailsSendTo.map(email => {
                    return email.value;
                });
                this.sendMails(mails);
            }
        });
    };

    sendMails = emails => {
        const currentUser = getAuthUser();
        sendGridEmail(
            getInviteToAnswer(
                emails,
                currentUser.firstName,
                this.state.userMessage,
                `${window.location.origin}/preview/${this.props.post.uid}`,
                this.props.categoryLabel
            )
        );
        this.toggle();
    };

    onInputChange = (options, values, search) => {
        let labels = values.map(function (value) {
            return value.label;
        });
        if (search.trim().length === 0 || labels.indexOf(search.trim()) !== -1) return null;
        return { label: search.trim(), value: search.trim() };
    };

    toggle = () => {
        const { inviteAllUsers } = this.state;
        this.props.toggle(inviteAllUsers);
    };

    updatePost = () => {
        let emails = [];
        const newPost = { ...this.props.post };

        if (!this.state.inviteAllUsers) {
            const teamUsers = this.state.selectedTeams
                ? this.state.userTeams.find(ut => ut.label === this.state.selectedTeams.label)
                      .invitedUsers
                : [];
            const users = this.state.selectedUsers.map(su => su.value);

            emails = [...teamUsers, ...users];

            newPost.inviteColleagues = !newPost.inviteColleagues
                ? []
                : newPost.inviteColleagues.filter(ic => ic !== INVITE_ALL_USERS);
            newPost.inviteColleagues = [...new Set([...newPost.inviteColleagues, ...emails])];

            updatePost(newPost).then(result => {
                if (result) {
                    this.sendMails(emails);
                }
            });
        } else {
            newPost.inviteColleagues = [INVITE_ALL_USERS];

            updatePost(newPost);
            this.toggle();
        }
    };

    valueHandler = items => {
        this.setState({ selectedTeams: items ? items : [] });
    };

    handleInviteAllCheckboxChecked = () => {
        this.setState({ inviteAllUsers: !this.state.inviteAllUsers });
    };

    TeamValueContainer = ({ children, ...props }) => {
        return (
            components.ValueContainer && (
                <components.ValueContainer {...props}>
                    {!!children && <InviteTeamsLogo />}
                    {children}
                </components.ValueContainer>
            )
        );
    };

    IndividualValueContainer = ({ children, ...props }) => {
        return (
            components.ValueContainer && (
                <components.ValueContainer {...props}>
                    {!!children && <InviteIndividualLogo />}
                    {children}
                </components.ValueContainer>
            )
        );
    };

    render() {
        const { modal } = this.props;
        const { inviteAllUsers } = this.state;

        return (
            <Modal isOpen={modal} toggle={this.toggle} className="post-invite-modal">
                <ModalHeader toggle={this.toggle}>
                    <InviteFriendIcon />
                    <b className="ml-3 mr-1">Invite users</b> to answer your question
                </ModalHeader>
                <ModalBody>
                    <div className="d-flex flex-column justify-content-between align-items-center w-100">
                        <div className="post-invite-modal__invite-all-container">
                            <Checkbox
                                value={inviteAllUsers}
                                text={
                                    IS_SIDEKICK_APP
                                        ? 'Invite all Sidekick talent'
                                        : 'Invite all Sidekick Network users'
                                }
                                onClick={this.handleInviteAllCheckboxChecked}
                            />
                        </div>
                        <div className="post-invite-modal__container my-3 p-5 d-flex justify-content-between flex-column">
                            <div>
                                <CreatableSelect
                                    className="create-post__invite-individual-container"
                                    classNamePrefix="react-select"
                                    components={{
                                        ValueContainer: this.IndividualValueContainer,
                                    }}
                                    placeholder="Invite individuals"
                                    isDisabled={inviteAllUsers}
                                    isMulti={true}
                                    isClearable={false}
                                    onChange={this.onUsersSelect}
                                />
                            </div>
                            <div>
                                <Select
                                    className="create-post__invite-team-container"
                                    classNamePrefix="react-select"
                                    components={{ ValueContainer: this.TeamValueContainer }}
                                    placeholder="Invite team"
                                    isDisabled={inviteAllUsers}
                                    options={this.state.userTeams}
                                    onChange={this.onTeamSelect}
                                />
                            </div>
                        </div>
                        <div className="post-invite-modal__done-button-container">
                            <input
                                className="done-button"
                                type="button"
                                value="Done"
                                onClick={this.updatePost}
                            />
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default PostInviteModal;
